var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SiteNavigation',{attrs:{"username":_vm.username}}),_c('div',[_c('router-view')],1),_c('footer',[_c('p',{staticClass:"version-info"},[_vm._v(_vm._s(_vm.version))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }